import React, { FC } from "react";
import { TAB_CAMPAIGNS, PATH_CAMPAIGNS, PATH_ASSET } from "constants/paths";
import TabOptions from "modules/Common/Components/TabOptions";
import styled from "styled-components";
import { getQueryParam } from "utils";
import { PageParams } from "modules/Campaigns/AssetsWithOutCampaigns/Components/AssetsWithoutCampaignTab";
import { useLocation, useParams } from "react-router";
import { ASSET_TYPE } from "../../../../constants/index";
import CreateAsset from "modules/Campaigns/CampaignAssets/Components/CreateAsset";
import ButtonRightIconGreen from "modules/Common/Components/ButtonRightIconGreen";
import PlusGreen from "../../../../assets/img/icons/Article/Plus.svg";

interface IAssetsTab {
  tab?: string;
  assetType?: string;
}

const AssetsTab: FC<IAssetsTab> = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { tab, assetType } = props;
  const campaignId = getQueryParam("campaign_id");
  const assetId = getQueryParam("asset_id");
  let queryString = campaignId !== "" ? `campaign_id=${campaignId}&` : "";
  queryString += assetId !== "" ? `asset_id=${assetId}` : "";

  const tabsArrayHybrid = [
    {
      pillName: "Dashboard",
      to: `/${PATH_CAMPAIGNS}/content?${searchParams}`,
      isActive: tab === undefined || tab === "/",
      id: "dashboard-tab"
    },
    {
      pillName: "SmartSourced Content",
      to: `/${PATH_CAMPAIGNS}/content/${TAB_CAMPAIGNS.SOURCED_CONTENT}?${searchParams}`,
      isActive: tab === TAB_CAMPAIGNS.SOURCED_CONTENT,
      id: "smart-sourced-content-tab"
    },
    {
      pillName: "Favorites",
      to: `/${PATH_CAMPAIGNS}/content/${TAB_CAMPAIGNS.FAVORITES}?${searchParams}`,
      isActive: tab === TAB_CAMPAIGNS.FAVORITES,
      id: "favorites-tab"
    },
    {
      pillName: "Audience",
      to: `/${PATH_CAMPAIGNS}/content/${TAB_CAMPAIGNS.AUDIENCE}?${searchParams}`,
      isActive: tab === TAB_CAMPAIGNS.AUDIENCE,
      id: "audience-tab"
    },
    {
      pillName: "Previous Content",
      to: `/${PATH_CAMPAIGNS}/content/${TAB_CAMPAIGNS.PREVIOUS_CONTENT}?${searchParams}`,
      isActive: tab === TAB_CAMPAIGNS.PREVIOUS_CONTENT,
      id: "previous-content-tab"
    },
    {
      pillName: "Sent",
      to: `/${PATH_CAMPAIGNS}/content/${TAB_CAMPAIGNS.PREVIOUSLY_SENT}?${searchParams}`,
      isActive: tab === TAB_CAMPAIGNS.PREVIOUSLY_SENT,
      id: "sent-tab"
    },
  ];

  const tabsArrayAdHoc = [
    {
      pillName: "Dashboard",
      to: `/${PATH_CAMPAIGNS}/content?${queryString}`,
      isActive: tab === undefined || tab === "/",
    },
    {
      pillName: "Audience",
      to: `/${PATH_CAMPAIGNS}/content/${TAB_CAMPAIGNS.AUDIENCE}?${queryString}`,
      isActive: tab === TAB_CAMPAIGNS.AUDIENCE,
    },
  ];
  return (
    <div className="margin-bottom-sm margin-top-sm d-flex">
      <Wrapper>
        {assetType && <TabOptions tabArray={assetType === ASSET_TYPE.HYBRID ? tabsArrayHybrid : tabsArrayAdHoc} />}
      </Wrapper>
      <div className="button-and-search-icon ms-3">
        <CreateAsset
          campaignId={campaignId}
          noRedirection={false}
          redirectRoute={"source"}
          wrapperclass={"fixed-position Popover-share-sidebar"}
        >
          <ButtonRightIconGreen
            icon={PlusGreen}
            label="Create New Email"
            green="green"
            classBtn=""
            classIcon="plus15"
            idBtn="create-new-email-btn"
          />
        </CreateAsset>
      </div>
    </div>
  );
};

export default AssetsTab;

const Wrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  margin-left: -5px;
  padding-top: 12px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-bottom: 12px !important;
    padding-top: 9px;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    li {
      margin: 5px 5px;
    }
  }
`;
